<div
    *ngrxLet="command() as currentCommand"
    class="st-notes-command-dialog__body">
    <st-text-field
        showLinks
        class="st-notes-command-dialog__text-area"
        [placeholder]="ProductionCommandsDefaultLabels[currentCommand.commandType]"
        [value]="currentCommand[ProductionFieldName.TEXT]"
        (onEnter)="onEnterSaveCommand($event)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.TEXT)" />
</div>
